/** "$1,400" or "Product only" */
export const money = (n: number | null | undefined) =>
  n && n > 0 ? `$${Math.round(n).toLocaleString()}` : 'Product only'

/** The kinds of deals a campaign can be. Mirrors packages/shared-db/dealTypes.ts. */
/**
 * 'content' is the older campaign flow (concept, video, live). Existing campaigns can still be
 * content deals, but brands only pick from the three deal types below.
 */
export type DealType = 'content' | 'gifting' | 'appearance' | 'licensing'

/**
 * Each kind of deal, in a marketer's words: the label brands pick, what it is also called in
 * their world (`aka`), and what happens (`blurb`). Setup shows all three lines on every option.
 */
export const DEAL_TYPE_OPTIONS: { id: DealType; label: string; aka: string; blurb: string }[] = [
  {
    id: 'licensing',
    label: 'Content for your ads',
    aka: 'UGC, licensed content, whitelisted or partnership ads',
    blurb:
      'Athletes make video or photos you approve. Every piece is licensed for your paid media for 30 days, longer if you extend. They can post it on their own channels too.',
  },
  {
    id: 'gifting',
    label: 'Gifting with a guaranteed post',
    aka: 'Product seeding, with expectations',
    blurb:
      'You ship product. The athlete opts in and must post, and earns bonuses you set as the views come in. $25 per athlete, 30 days of paid usage included.',
  },
  {
    id: 'appearance',
    label: 'In-person appearance',
    aka: 'Signings, store events, clinics, campus pop-ups',
    blurb:
      'Athletes show up for your event or location. You confirm afterwards and they get paid.',
  },
]

/** "Nov 15" from "2026-11-15" or an ISO timestamp, without the timezone shifting the day */
export const shortDate = (value: string | null | undefined) => {
  if (!value) return ''
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return ''
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

/** Short names for lists and tables */
export const DEAL_TYPE_LABELS: Record<DealType, string> = {
  content: 'Content',
  gifting: 'Gifting',
  appearance: 'Appearance',
  licensing: 'Licensing',
}
